import { IncludesStream } from '@sb/library/data-models';

export enum ProfileImageSize {
    Small = 'sb-avatar-small',
    Medium = 'sb-avatar-medium',
    Large = 'sb-avatar-large',
    XLarge = 'sb-avatar-xlarge',
    Edit = 'sb-avatar-edit'
}

export enum ProfileImageCrop {
    Automatic,
    Center
}

export class ProfileImageUploadData {
    Files!: File[];
    UseFaceDetection!: boolean;
}

export class ProfileImageData {
    Data?: UploadData[];
    Deleted: boolean = false;

    constructor(initializer?: Partial<ProfileImageData>) {
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

interface UploadData {
    ID?: string;
    InputItem?: IncludesStream;
    File: File;
}

export enum ProfileCardMode {
    Avatar,
    Logo,
    None
}
